// Marketing banner tracking (inline banners + popups).
//
// Migrated to GA4's recommended promotion events, which is exactly what these
// banners are: view_promotion / select_promotion. GA4's "Promotions" report
// then works with no extra setup. There's no standard name for dismissing a
// promotion, so that one stays custom.
//
// Callers still pass the old action names — the mapping happens here so the
// two call sites don't need to care. The old campaign_* params ride along in
// the payload as well, so the legacy events fired by track()'s dual-fire keep
// reporting identically to before the migration.
import { track } from "@/lib/track";

const STANDARD_NAME = {
  campaign_impression: "view_promotion",
  campaign_click: "select_promotion",
  campaign_dismiss: "dismiss_promotion",
};

export const trackCampaign = (action, campaign, extra = {}) => {
  if (!campaign) return;
  const name = STANDARD_NAME[action] || action;
  const title = campaign.title || "(untitled)";
  track(name, {
    // GA4 recommended promotion params
    promotion_id: campaign.id,
    promotion_name: title,
    creative_slot: campaign.placement,
    // legacy params, kept so the dual-fired campaign_* events are unchanged
    campaign_id: campaign.id,
    campaign_title: title,
    placement: campaign.placement,
    event_category: "Campaign",
    event_label: title,
    ...extra,
  });
};
